
const zoomsize = 0.8
const unit_type_list =  [
      {
      name: "1 BEDROOM",
      color: "#D4EFFC",
      to_type: [
        {name: "TYPE A1 - 45 SQM",type: "A-G",color: "#D4EFFC",imgnames:83,typecls: [
          { w: '18.5%', h: '19%', x: '36%', y: '32.5%',color: '#D4EFFC',type:"A1",ctname:"A1" },
          ],},
        {name: "TYPE A2 - 46 SQM",type: "A-G",color: "#D4EFFC",imgnames:98,typecls: [
          { w: '5.5%', h: '17%', x: '31.5%', y: '33%',color: '#D4EFFC',type:"A2",ctname:"A2" },],},

      ],
    },
    {
      name: "1 BEDROOM + STUDY",
      color: "#D4EFFC",
      to_type: [
        {name: "TYPE B1 - 51 SQM",type: "A-G",color: "#D4EFFC",imgnames:98,typecls: [
          { w: '6%', h: '6%', x: '64%', y: '46.5%',color: '#D4EFFC',type:"B1",ctname:"B1" },],},
        {name: "TYPE B2 - 55 SQM",type: "A-G",color: "#D4EFFC",imgnames:81,typecls: [
          { w: '3%', h: '15%', x: '54%', y: '32%',color: '#D4EFFC',type:"B2",ctname:"B2" },],},
      ],
    },
     {
      name: "2 BEDROOM",
      color: "#FFF9B8",
      to_type: [
        {name: "TYPE C1 - 66 SQM",type: "B1-G",color: "#FFF9B8",imgnames:0,typecls: [
          { w: '46.5%', h: '21.5%', x: '29.5%', y: '37%', color: '#D4EFFC',type:"C1",ctname:"C1" },],},
        {name: "TYPE C2 - 66 SQM",type: "B1-G",color: "#FFF9B8",imgnames:150,typecls: [
          { w: '10%', h: '16.5%', x: '32%', y: '47.5%', color: '#D4EFFC',type:"C2",ctname:"C2" },],},
        {name: "TYPE C3 - 67 SQM",type: "B1-G",color: "#FFF9B8",imgnames:81,typecls: [
          { w: '11%', h: '17.5%', x: '40%', y: '33%', color: '#D4EFFC',type:"C3",ctname:"C3" },
        ],},
      ],
    },
    {
      name: "2 BEDROOM + STUDY",
      color: "#FFF9B8",
      to_type: [
        {
          name: "TYPE D - 67 SQM",
          type: "B1-G",
          color: "#FFF9B8",
          imgnames:98,
          typecls: [
            { w: '8%', h: '8.5%', x: '64.5%', y: '52.5%', color: '#D4EFFC',type:"D",ctname:"D" },
          ],
        },
      ],
    },
    {
      name: "2 BEDROOM + GUEST",
      color: "#FFF9B8",
      to_type: [
        {
          name: "TYPE E - 82 SQM",
          type: "B1-G",
          color: "#FFF9B8",
          imgnames:98,
          typecls: [
            { w: '8%', h: '9.5%', x: '71.5%', y: '51%', color: '#D4EFFC',type:"E",ctname:"E" },

          ],
        },
      ],
    },
    {
      name: "3 BEDROOM",
      color: "#FFF9B8",
      to_type: [
        // {name: "TYPE E - 45 SQM",type: "B1-G",color: "#FFF9B8",imgnames:0,typecls: [{ w: '9%', h: '21.5%', x: '20.5%', y: '37%', z:'356deg', color: '#D4EFFC',type:"F",ctname:"F" },],},
        {name: "TYPE F1 - 89 SQM",type: "B1-G",color: "#FFF9B8",imgnames:150,typecls: [{ w: '11%', h: '22.5%', x: '51.5%', y: '37%', color: '#D4EFFC',type:"F1",ctname:"F1" },],},
        {name: "TYPE F2- 91 SQM",type: "B1-G",color: "#FFF9B8",imgnames:150,typecls: [{ w: '10%', h: '21.5%', x: '70%', y: '37%', color: '#D4EFFC',type:"F2",ctname:"F2" },],},
        {name: "TYPE F3- 92 SQM",type: "B1-G",color: "#FFF9B8",imgnames:0,typecls: [{ w: '10%', h: '21.5%', x: '74.5%', y: '37%', color: '#D4EFFC',type:"F3",ctname:"F3" },],},
      ],
    },
    {
      name: "3 BEDROOM + GUEST",
      color: "#FFF9B8",
      to_type: [
        {name: "TYPE G1 - 95 SQM",type: "B1-G",color: "#FFF9B8",imgnames:150,typecls: [{ w: '11%', h: '13%', x: '41%', y: '47%', color: '#D4EFFC',type:"G1",ctname:"G1" },],},
        {name: "TYPE G2 - 102 SQM",type: "B1-G",color: "#FFF9B8",imgnames:100,typecls: [{ w: '12%', h: '7%', x: '67.5%', y: '46%', color: '#D4EFFC',type:"G2",ctname:"G2" },],},
        {name: "TYPE G3- 109 SQM",type: "B1-G",color: "#FFF9B8",imgnames:81,typecls: [{ w: '9%', h: '20.5%', x: '24.5%', y: '35%', color: '#D4EFFC',type:"G3",ctname:"G3" },],},
        {name: "TYPE G4- 110 SQM",type: "B1-G",color: "#FFF9B8",imgnames:50,typecls: [{ w: '8%', h: '9.5%', x: '53.5%', y: '39.5%', color: '#D4EFFC',type:"G4",ctname:"G4" },],},
      ],
    },
    {
      name: "4 BEDROOM",
      color: "#FFF9B8",
      to_type: [
        {
          name: "TYPE H - 117 SQM",
          type: "B1-G",
          color: "#FFF9B8",
          imgnames:98,
          typecls: [
            { w: '8.5%', h: '7.5%', x: '56.5%', y: '47%', color: '#D4EFFC',type:"H",ctname:"H" },
          ],
        },
      ],
    },
  ]






export default {
    unit_type_list,
    zoomsize
};





